/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner, Modal, Button } from "react-bootstrap";

import "./CandidateDetails.scss";
import { Carousel } from "antd";
import PhoneInput from "react-phone-input-2";
import { nameExtractor } from "../../../_helpers/nameExtractor";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { SkillSearchInput } from "../../../_uiComponents/Search/SkillSearchInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCandidateDetails from "./useCandidateDetails";
import { TimezoneSearchInput } from "../../../_uiComponents/Search/TimezoneSearchInput";

export default (props) => {
  const {
    skillsTagsAdded,
    loading,
    user,
    searchKeywordsSuggestions,
    onKeywordsTagsAddition,
    onKeywordsTagsDelete,
    onInputBlur,
    onTimeZoneChange,
    onSignIn,
    onImageResume,
    onSubmit,
    contactNumberHandler,
    setPhoneInput,
    isTimezoneMessageModal,
    onCloseTimezoneMessageModal,
  } = useCandidateDetails(props);

  return (
    <>
      <div className="common-login role-selection-wrapper">
        <Container className="px-0">
          <div className="row no-gutters">
            <div className="col-lg-6 d-none d-md-block">
              <div className="left-img">
                <div className="login-slider">
                  <Carousel autoplay arrows>
                    <div className="slider-content">
                      <img
                        src="/assets/images/slider-img-1.svg"
                        alt="slider-img"
                        className="slider-img"
                      />
                      <h2 className="text-white mb-2">
                        Simplify Your Recruitment Process
                      </h2>
                      <p className="font-weight-medium text-white">
                        Make recruitment easy for businesses of all sizes.
                        Streamline your hiring process, from job posting to
                        candidate management, and discover the best-fit
                        candidates for your team with Jigsaw's innovative
                        platform.
                      </p>
                    </div>
                    <div className="slider-content">
                      <img
                        src="/assets/images/slider-img-2.svg"
                        alt="slider-img"
                        className="slider-img"
                      />
                      <h2 className="text-white mb-2">
                        Rescue Hiring Manger & Candidate From Fate
                      </h2>
                      <p className="font-weight-medium text-white">
                        Don't leave recruitment process of hiring manager and
                        candidate’s career to fate. Take control with Jigsaw's
                        intuitive platform, designed to simplify recruitment and
                        elevate your professional growth. Say goodbye to
                        uncertainty and achieve your goals with Jigsaw.
                      </p>
                    </div>
                    <div className="slider-content">
                      <img
                        src="/assets/images/slider-img-3.svg"
                        alt="slider-img"
                        className="slider-img"
                      />
                      <h2 className="text-white mb-2">
                        Take Control of Your Career with Jigsaw!
                      </h2>
                      <p className="font-weight-medium text-white">
                        Unlock your full potential and achieve your career goals
                        with Jigsaw. Our intuitive platform empowers you with
                        the tools and resources you need to succeed, streamlined
                        job searching and interview preparation. Take control of
                        your future today with Jigsaw.
                      </p>
                    </div>
                  </Carousel>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="form-wrapper py-4 h-100">
                <ul className="steps d-flex align-items-center justify-content-between mx-auto mb-4">
                  <li className="step completed">
                    <span>1</span>
                  </li>
                  <li className="step completed">
                    <span>2</span>
                  </li>
                  <li className="step">
                    <span>3</span>
                  </li>
                </ul>
                <h1 className="mb-2">Get Started!</h1>

                <div className="form-group">
                  <p className="font-weight-medium">Time Zone</p>
                  <TimezoneSearchInput
                    className="form-control"
                    placeholder="Search Timezone..."
                    onSearchSelect={(item) =>
                      onTimeZoneChange({
                        target: {
                          value: item,
                          name: "timezone",
                        },
                      })
                    }
                    clearSearch={false}
                    defaultTimezoneValue={user?.user_details?.timezone}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="EmailId" className="mb-2 font-weight-medium">
                    Upload Resume
                  </label>
                  {user?.user_details &&
                  user.user_details?.user_meta_info &&
                  user.user_details.user_meta_info?.resume ? (
                    <div className="form-control h-auto py-3">
                      {nameExtractor(user.user_details.user_meta_info.resume)}
                    </div>
                  ) : (
                    <input
                      type="file"
                      className="form-control"
                      name="resume"
                      accept=".pdf"
                      onChange={onImageResume}
                    />
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="EmailId" className="mb-2 font-weight-medium">
                    LinkedIn Profile Url
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name={"linkedin_url"}
                    placeholder="eg:https://linkedin.com/"
                    defaultValue={user?.linkedin_url}
                    onBlur={onInputBlur}
                  />
                </div>
                <div className="form-group">
                  <p className="font-weight-medium">
                    <span className="text-danger">* </span>Skills
                  </p>
                  <div className="bg-white p-4 rounded-lg border mw-100">
                    <div className="d-flex flex-wrap align-items-center">
                      {skillsTagsAdded &&
                        Array.isArray(skillsTagsAdded) &&
                        skillsTagsAdded.map((tag, index) => (
                          <div
                            className="h4 bg-grey-3 py-1 rounded font-weight-normal text-dark px-2 mr-2 text-capitalize mb-3"
                            key={index}
                          >
                            {tag?.skill_name}
                            <FontAwesomeIcon
                              icon={faXmark}
                              className="ml-3 cursor-pointer"
                              onClick={() => onKeywordsTagsDelete(tag)}
                            />
                          </div>
                        ))}
                    </div>
                    <SkillSearchInput
                      className="form-control mw-100"
                      placeholder="Search Skill..."
                      onSearchSelect={(item) => onKeywordsTagsAddition(item)}
                      clearSearch={true}
                    />

                    {searchKeywordsSuggestions &&
                    Array.isArray(searchKeywordsSuggestions) &&
                    searchKeywordsSuggestions.length ? (
                      <ul
                        className="rounded-lg bg-white shadow position-absolute w-75 pb-4"
                        style={{ left: "40px", top: "70%", zIndex: 9 }}
                      >
                        {Array.isArray(searchKeywordsSuggestions) &&
                          searchKeywordsSuggestions.map((item, index) => (
                            <li
                              className="p-0 fs-smallest"
                              onClick={(e) => onKeywordsTagsAddition(item)}
                              key={index}
                            >
                              <p className="fs-smallest mx-1 pl-lg-5 pl-md-4">
                                {item}
                              </p>
                            </li>
                          ))}
                      </ul>
                    ) : null}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="" className="mb-2 font-weight-medium">
                    Phone Number
                  </label>
                  <PhoneInput
                    country={"us"}
                    name={"phone"}
                    inputClass={"form-control w-100"}
                    value={user?.user_details?.user_meta_info?.phone}
                    onBlur={contactNumberHandler}
                    onChange={setPhoneInput}
                  />
                </div>

                <div className="mt-auto py-4">
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      onSubmit();
                    }}
                  >
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Spinner animation="border" variant="white" />
                      </div>
                    ) : (
                      "Next"
                    )}
                  </button>
                </div>
                <div className="d-flex align-items-center  mt-auto py-4 justify-content-center">
                  <p>
                    Go back to website{" "}
                    <span
                      onClick={onSignIn}
                      className="text-primary font-weight-medium cursor-pointer"
                    >
                      JIGSAW.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <Modal
          centered
          show={isTimezoneMessageModal}
          onHide={onCloseTimezoneMessageModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Please select your timezone as per your availability. It cannot be
              changed once selected!
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={onCloseTimezoneMessageModal}>
              Done
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
